var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","dark":"","rounded":"","small":""},on:{"click":function($event){return _vm.generatePDFReport()}}},[_vm._v("Rachunek wykładowcy")])
}
var staticRenderFns = []

export { render, staticRenderFns }